import React from "react";
import Modal from "../../components/modal/Modal";
import { useNavigate } from "react-router-dom";

const LogoutModalPopup = ({ visible, onClose, getTranslateText }) => {
  const navigate = useNavigate();

  const getTextByKey = (key, fallback) => {
    const item = getTranslateText?.data?.find((item) => item.pageKey === key);
    return item?.keyValue || fallback;
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/select/language");
    onClose(); // Use the passed onClose handler
  };

  return (
    <Modal visible={visible} onClose={onClose}>
      <div className="w-[90%] max-w-[400px] mx-auto">
        <div className="bg-[#fff] px-6 py-6 rounded-[30px] flex flex-col justify-center items-center">
          <img src="../Images/sad_puzzle.svg" alt="Puzzle sad Image" />
          <h5 className="font-semibold text-[20px] my-2 text-center">
            {getTextByKey("label_logout", "Are you sure, you want to Logout ?")}
          </h5>

          <div className="flex justify-around w-full gap-4">
            <button
              onClick={handleLogout}
              className="bg-gradient-to-r from-[#E7EAFF] to-[#E7EAFF] text-[#3C57AD] px-[50px] py-[10px] rounded-[10px] mt-[20px] text-center"
            >
              {getTextByKey("alert_yes", "Yes")}
            </button>
            <button
              onClick={onClose}
              className="bg-gradient-to-r from-[#2C3EA2] to-[#192867] text-white px-[50px] py-[10px] rounded-[10px] mt-[20px] text-center"
            >
              {getTextByKey("alert_no", "No")}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default LogoutModalPopup;
